import { createStyles } from 'antd-style'

export const useStyles = createStyles({
  wrapper: {
    p: { margin: 0 }
  }
})
